<!--
  Модальный просмотр вложения чата поверх текущей переписки.
-->
<template>
  <BaseAttachmentPreview
    :attachment="attachment"
    @close="$emit('close')"
  >
    <template #audio>
      <div class="chat-attachment-preview__audio">
        <strong class="chat-attachment-preview__file-name">
          {{ attachmentDisplayName }}
        </strong>
        <ChatAudioAttachment :attachment="attachment" variant="incoming" />
      </div>
    </template>
  </BaseAttachmentPreview>
</template>

<script>
import ChatAudioAttachment from "@/components/Chat/AudioAttachment.vue";
import { attachmentName } from "@/utils/fileUtils";

export default {
  name: "ChatAttachmentPreviewModal",

  components: {
    ChatAudioAttachment,
  },

  props: {
    attachment: {
      type: Object,
      required: true,
    },
  },

  emits: ["close"],

  computed: {
    attachmentDisplayName() {
      return attachmentName(this.attachment) || "Вложение";
    },
  },
};
</script>

<style scoped>
.chat-attachment-preview__audio {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: min(420px, 100%);
  padding: 18px;
  border-radius: 8px;
  background: #fff;
  color: #333;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.28);
}

.chat-attachment-preview__file-name {
  max-width: 100%;
  color: #222;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
}
</style>
